import { StyleSheet, Text, View } from './components/base_components';
import { withRouter } from 'inferno-router';
import BusyComponent from './components/busy_component';

import UserStore from './stores/user_store';

import ModalDialog from './components/dialogs/modal_dialog';
import WideButton from './components/buttons/wide_button';

const styles = StyleSheet.create({
  loginScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  button: {
    marginTop: '5em',
  },
});

type Props = {
  history: any;
};
type State = {};

class FBLoginComplete extends BusyComponent<Props, State> {
  state = {
    is_busy: true,
  };
  componentDidMount() {
    if (UserStore.isLoggedIn()) {
      this.props.history.replace('/');
    } else {
      const access_token = _getUrlAccessToken();
      if (access_token) {
        UserStore.loginWithToken(access_token, err => {
          this.clearBusy();
          if (err) {
            ModalDialog.alert('Login Failed.');
            this.props.history.replace('/login');
          } else {
            ModalDialog.error('Login Success.');
            this.props.history.replace('/');
          }
        });
      } else {
        this.clearBusy();
        ModalDialog.error('Login Failed.');
        this.props.history.replace('/login');
      }
    }
  }

  _onFacebookLogin = () => {
    if (this.setBusy()) {
      UserStore.login(err => {
        this.clearBusy();
        if (err) {
          ModalDialog.error('Login Failed.');
        } else {
          ModalDialog.alert('Login Success.');
          this.props.history.replace('/');
        }
      });
    }
  };

  render() {
    return (
      <View style={styles.loginScreen}>
        <Text style={styles.text}>Login</Text>
        <WideButton
          style={styles.button}
          text='Facebook Login'
          onPress={this._onFacebookLogin}
        />
        <BusyComponent.BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
export default withRouter(FBLoginComplete);

function _getUrlAccessToken(): string | undefined {
  let ret;
  if (window.location.hash && window.location.hash.length > 0) {
    const hash = window.location.hash.slice(1);
    const hash_map: any = {};
    hash
      .split('&')
      .map(k_v => k_v.split('='))
      .forEach(([k, v]) => {
        hash_map[decodeURIComponent(k)] = decodeURIComponent(v);
      });
    ret = hash_map.access_token;
  }
  return ret;
}
